/*
 * @Author: liyxt
 * @Date: 2020-02-10 14:40:37
 * @LastEditors: bbqin
 * @LastEditTime: 2022-04-28 15:38:40
 * @Description: file content
 */
import React, { Component } from 'react';
// import OriginLoading from 'bee-loading';
// import { Spin as OriginLoading } from '@tinper/next-ui';
import OriginLoading from '@tinper/next-ui/lib/wui-spin/src';
import classNames from 'classnames';
import { getMultiLang } from '../../api/getMultiLang';
import { getDocument } from '../../api/qiankunContext';
 
// require('bee-loading/build/Loading.css');
require('./loading.less');

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getPopupContainer = ()=>{
            return getDocument();
        };
    }

    componentWillMount() {
        let callback = langJson => {
            this.setState({ langJson });
        };
        // moduleId为所需加载json文件夹名称前缀
        getMultiLang({ moduleId: 'base_loading', callback });
    }

    render() {
        let { wrapperClassName, show, spinning, container, getPopupContainer, tip, ...others } = this.props;
        spinning = spinning || show;
        getPopupContainer = getPopupContainer || container || this.getPopupContainer;
        let langJson = this.state?.langJson || {};
        return <OriginLoading {...others}
            wrapperClassName={classNames(wrapperClassName,
                'base-loading', { 'base-loading-spin-show': spinning })}
            spinning={spinning}
            getPopupContainer={getPopupContainer}
            backDropClassName={'base-loading-back-drop'}
            tip={tip || langJson['loading-0001']}
        />;
    }
}

export default Loading;
